export default __webpack_public_path__ + "static/media/img-horse-left.01726698.jpg";